import { Flex } from 'components/Flex';
import { useFetchJaneByIdDataContext } from 'components/JaneModal/FetchJaneById.data.context';
import { JaneName } from 'components/JaneModal/views/JaneDetailsView/ReviewsTab/ReviewsTab.styled';
import {
  ColorDot,
  TimeWrapper,
  FlexWrapper,
  ActivityContentWrapper,
  TextWrapper,
} from 'components/JaneModal/views/JaneDetailsView/ActivityTab/ActivityTab.styled';
import { Fragment, useContext } from 'react';
import { SectionDivider } from 'components/ShiftModal/ShiftModal.styled';
import { humanReadableDate } from 'components/JaneModal/JaneModal.constants';
import {
  LoadingWrapper,
  Text,
} from 'components/JaneModal/views/JaneDetailsView/GeneralTab/GeneralTab.styled';
import {
  Activity,
  auditEvents,
  getActivityColorByEvent,
} from 'components/JaneModal/views/JaneDetailsView/ActivityTab/ActivityTab.types';
import i18next from 'i18next';
import { BKJLoadingSpinner } from '@awais4123/fillify-design-library';
import { TeamMemberPageContext } from 'pages/TeamMemberPage/TeamMemberPage.context';
import { InfiniteScrollLoading } from 'components/InfiniteScrollLoading';
export const ActivityTab = () => {
  const { data, activities, isLoading, activitiesMeta, fetchNextPageActivities } =
    useFetchJaneByIdDataContext();

  const hasNextPage =
    activitiesMeta?.current_page &&
    activitiesMeta?.total_pages &&
    activitiesMeta.current_page < activitiesMeta.total_pages;

  const {
    values: { location },
  } = useContext(TeamMemberPageContext);
  if (!data)
    return (
      <LoadingWrapper>
        <BKJLoadingSpinner variant="Default" />
      </LoadingWrapper>
    );
  const { shorthandName = '' } = data;
  return (
    <Fragment>
      <FlexWrapper>
        <Flex flexDirection="column" width="100%">
          <JaneName>{shorthandName}</JaneName>
          <SectionDivider variant="Thin" />
        </Flex>
        <Flex flexDirection="column" width="100%" gap="32px">
          {activities?.length > 0 ? (
            activities.map((item: Activity) => (
              <ActivityContentWrapper key={item.id}>
                <TimeWrapper>{humanReadableDate(item?.created_at, location?.timeZone)}</TimeWrapper>
                <Flex gap="6px" width="100%">
                  <ColorDot color={getActivityColorByEvent(item?.event)}>•</ColorDot>
                  <TextWrapper>
                    {auditEvents(item?.event, item?.feedable?.shift_ids[0])}
                  </TextWrapper>
                </Flex>
              </ActivityContentWrapper>
            ))
          ) : (
            <Flex height="581px" justifyContent="center" alignItems="center">
              <Text>{i18next.t('team_member:THERE_IS_NO_ACTIVITY')}</Text>
            </Flex>
          )}
          {hasNextPage && !isLoading && (
            <Flex
              justifyContent="center"
              alignItems="center"
              width="100%"
              padding="24px 0px 0px 0px"
            >
              <InfiniteScrollLoading onViewportEnter={fetchNextPageActivities} />
            </Flex>
          )}
        </Flex>
      </FlexWrapper>
    </Fragment>
  );
};
